(function () {
  'use strict';

  var root = document.documentElement;
  var OPEN_CLASS = 'atlekx-mega-open';
  var SOLID_CLASS = 'atlekx-mega-solid';
  var MEGA_DETAILS = '.site-nav--is-megamenu .site-nav__details';
  var closeTimers = new WeakMap();

  function closeDelay() {
    var header = document.getElementById('SiteHeader');
    if (!header) return 250;
    var raw = parseInt(header.getAttribute('data-atlekx-close-delay'), 10);
    return isNaN(raw) ? 250 : raw;
  }

  function navBreakpoint() {
    var header = document.getElementById('SiteHeader');
    if (!header) return 769;
    var raw = parseInt(header.getAttribute('data-atlekx-nav-bp'), 10);
    return isNaN(raw) ? 769 : raw;
  }

  function cancelClose(detail) {
    var timer = closeTimers.get(detail);
    if (timer) {
      window.clearTimeout(timer);
      closeTimers.delete(detail);
    }
  }

  function cancelAllCloses() {
    getMegaDetails().forEach(cancelClose);
  }

  function closeDetail(detail) {
    detail.removeAttribute('open');
    detail.setAttribute('aria-expanded', 'false');
    var summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function getAllNavDetails() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-section-type="header"] .site-nav__details')
    );
  }

  function closeDetailInstant(detail) {
    cancelClose(detail);
    detail.classList.add('atlekx-instant');
    closeDetail(detail);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        detail.classList.remove('atlekx-instant');
      });
    });
  }

  function closeSiblings(current) {
    var changed = false;
    getAllNavDetails().forEach(function (other) {
      if (other !== current && other.hasAttribute('open')) {
        closeDetailInstant(other);
        changed = true;
      }
    });
    return changed;
  }

  function scheduleClose(detail) {
    cancelClose(detail);
    var delay = closeDelay();

    if (delay <= 0) {
      closeDetail(detail);
      syncState();
      return;
    }

    closeTimers.set(
      detail,
      window.setTimeout(function () {
        closeTimers.delete(detail);
        if (detail.matches(':hover')) return;
        closeDetail(detail);
        syncState();
      }, delay)
    );
  }

  function getHeaderBottom() {
    var header = document.getElementById('SiteHeader') || document.querySelector('.site-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.bottom));
  }

  function updateMegaTop() {
    root.style.setProperty('--atlekxMegaTop', getHeaderBottom() + 'px');
  }

  function ensureScrim() {
    var scrim = document.querySelector('.atlekx-mega-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'atlekx-mega-scrim';
      document.body.appendChild(scrim);
      scrim.addEventListener('click', closeAllMega);
    }
    return scrim;
  }

  function getMegaDetails() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.site-nav--is-megamenu .site-nav__details')
    );
  }

  function anyOpen() {
    return getMegaDetails().some(function (d) {
      return d.hasAttribute('open');
    });
  }

  function closeAllMega() {
    getMegaDetails().forEach(function (d) {
      cancelClose(d);
      closeDetail(d);
    });
    root.classList.remove(OPEN_CLASS);
    root.classList.remove(SOLID_CLASS);
  }

  function solidHeaderEnabled() {
    var header = document.getElementById('SiteHeader');
    if (!header) return false;
    if (header.getAttribute('data-atlekx-solid-nav') !== 'true') return false;
    return header.getAttribute('data-overlay') === 'true';
  }

  function syncState() {
    if (anyOpen()) {
      updateMegaTop();
      root.classList.add(OPEN_CLASS);
      if (solidHeaderEnabled()) {
        root.classList.add(SOLID_CLASS);
      }
    } else {
      root.classList.remove(OPEN_CLASS);
      root.classList.remove(SOLID_CLASS);
    }
  }

  function initMegaMenu() {
    ensureScrim();
    updateMegaTop();

    var details = getMegaDetails();
    if (!details.length) return;

    details.forEach(function (d) {
      if (d.getAttribute('data-atlekx-bound') === 'true') return;
      d.setAttribute('data-atlekx-bound', 'true');
      d.addEventListener('toggle', function () {
        if (d.hasAttribute('open')) {
          cancelClose(d);
          closeSiblings(d);
        }
        syncState();
      });
    });

    if (root.getAttribute('data-atlekx-global') !== 'true') {
      root.setAttribute('data-atlekx-global', 'true');

      document.addEventListener(
        'mouseleave',
        function (event) {
          var target = event.target;
          if (!target || target.nodeType !== 1 || !target.matches) return;
          if (!target.matches(MEGA_DETAILS)) return;
          event.stopImmediatePropagation();
          if (target.hasAttribute('open')) scheduleClose(target);
        },
        true
      );

      document.addEventListener(
        'mouseover',
        function (event) {
          var target = event.target;
          if (!target || !target.closest) return;

          var detail = target.closest('.site-nav__details');
          if (!detail) return;

          cancelClose(detail);
          if (closeSiblings(detail)) syncState();
        },
        true
      );

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) closeAllMega();
      });

      window.addEventListener('resize', function () {
        updateMegaTop();
        if (window.innerWidth < navBreakpoint()) closeAllMega();
      });

      window.addEventListener(
        'scroll',
        function () {
          if (root.classList.contains(OPEN_CLASS)) updateMegaTop();
        },
        { passive: true }
      );
    }
  }

  function initMobilePanels() {
    var viewports = document.querySelectorAll('[data-mnav-viewport]');
    if (!viewports.length) return;

    Array.prototype.forEach.call(viewports, function (viewport) {
      if (viewport.getAttribute('data-atlekx-bound') === 'true') return;
      viewport.setAttribute('data-atlekx-bound', 'true');

      var container = viewport.closest('.atlekx-drawer') || document;
      var backBtn = container.querySelector('[data-mnav-back]');
      var titleEl = container.querySelector('[data-mnav-title]');
      var rootTitle = titleEl ? titleEl.textContent.trim() : '';
      var panels = viewport.querySelectorAll('[data-mnav-panel]');
      var stack = ['root'];

      function panelById(id) {
        return viewport.querySelector('[data-mnav-panel="' + id + '"]');
      }

      function headingOf(id) {
        if (id === 'root') return rootTitle;
        var panel = panelById(id);
        return (panel && panel.getAttribute('data-mnav-heading')) || rootTitle;
      }

      function render() {
        var currentId = stack[stack.length - 1];
        Array.prototype.forEach.call(panels, function (panel) {
          var id = panel.getAttribute('data-mnav-panel');
          panel.classList.remove('is-active', 'is-past');
          if (id === currentId) {
            panel.classList.add('is-active');
            panel.scrollTop = 0;
          } else if (stack.indexOf(id) !== -1) {
            panel.classList.add('is-past');
          }
        });

        if (titleEl) titleEl.textContent = headingOf(currentId);

        if (backBtn) {
          if (stack.length > 1) {
            backBtn.removeAttribute('hidden');
            var label = backBtn.querySelector('[data-mnav-back-label]');
            if (label) label.textContent = headingOf(stack[stack.length - 2]);
          } else {
            backBtn.setAttribute('hidden', 'hidden');
          }
        }
      }

      viewport.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-mnav-open]');
        if (!opener || !viewport.contains(opener)) return;
        event.preventDefault();
        var targetId = opener.getAttribute('data-mnav-open');
        if (!panelById(targetId)) return;
        stack.push(targetId);
        render();
      });

      if (backBtn) {
        backBtn.addEventListener('click', function (event) {
          event.preventDefault();
          if (stack.length > 1) {
            stack.pop();
            render();
          }
        });
      }

      var closeBtn = container.querySelector('.js-drawer-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          window.setTimeout(function () {
            stack = ['root'];
            render();
          }, 400);
        });
      }

      render();
    });
  }

  /* ------------------------------------------------------------------
     Buscador: filtro automatico por tipo de producto
     Cuando lo que escribe el cliente es un tipo de producto (top, shorts,
     leggings...) o un sinonimo configurado, la busqueda se envia con el
     filtro nativo filter.p.product_type para que solo salga esa prenda.
     Los datos (tipos, sinonimos, modo) vienen en el formulario, desde
     snippets/predictive-search.liquid.
     ------------------------------------------------------------------ */
  function searchNormalize(value) {
    var text = String(value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function searchAliases(raw) {
    var map = {};
    String(raw || '').split(',').forEach(function (pair) {
      var idx = pair.indexOf(':');
      if (idx < 0) return;
      var key = searchNormalize(pair.slice(0, idx));
      var value = pair.slice(idx + 1).trim();
      if (key && value) map[key] = value;
    });
    return map;
  }

  function searchMatchType(term, types, aliases) {
    if (!term) return '';
    if (aliases[term]) return aliases[term];
    for (var i = 0; i < types.length; i++) {
      var type = searchNormalize(types[i]);
      if (type && (term === type || term === type + 's' || term === type + 'es')) return types[i];
    }
    return '';
  }

  function searchResolveType(form, value) {
    var mode = form.getAttribute('data-atlekx-type-mode') || 'exact';
    if (mode === 'off') return '';

    var types = [];
    try {
      types = JSON.parse(form.getAttribute('data-atlekx-types') || '[]') || [];
    } catch (e) {
      types = [];
    }

    var aliases = searchAliases(form.getAttribute('data-atlekx-aliases'));
    var term = searchNormalize(value);
    var found = searchMatchType(term, types, aliases);
    if (!found && mode === 'first') found = searchMatchType(term.split(' ')[0], types, aliases);
    return found;
  }

  function searchSyncType(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var type = searchResolveType(form, input.value);
    var hidden = form.querySelector('input[name="filter.p.product_type"][data-atlekx-auto]');

    if (type) {
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'filter.p.product_type';
        hidden.setAttribute('data-atlekx-auto', 'true');
        form.appendChild(hidden);
      }
      hidden.value = type;
    } else if (hidden) {
      hidden.remove();
    }
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || target.name !== 'q' || !target.closest) return;
    var form = target.closest('form[data-atlekx-types]');
    if (form) searchSyncType(form);
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[data-atlekx-types]')) searchSyncType(form);
    },
    true
  );

  /* ------------------------------------------------------------------
     Desplegable de busqueda: cantidad de productos configurable
     (el tema trae 3 fijos; se reemplaza la peticion con el limite elegido)
     ------------------------------------------------------------------ */
  function patchPredictiveLimit() {
    var Ctor = window.customElements && customElements.get('predictive-search');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.atlekxPatched) return;

    var original = Ctor.prototype.getSearchResults;
    if (typeof original !== 'function') return;

    Ctor.prototype.getSearchResults = function (searchTerm) {
      var form = this.querySelector('form');
      var limit = parseInt(form && form.getAttribute('data-atlekx-predictive-limit'), 10);
      if (!limit || limit < 1 || !window.theme || !theme.routes) return original.call(this, searchTerm);

      var params = this.paramUrl({
        q: searchTerm,
        'resources[limit]': Math.min(limit, 10),
        'resources[limit_scope]': 'each'
      });
      var self = this;

      fetch(theme.routes.predictiveSearch + '?' + params + '&section_id=search-results')
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results');
          if (!section) return;
          self.predictiveSearchResults.innerHTML = section.innerHTML;
          self.open();
          if (window.AOS) AOS.refreshHard();
        })
        .catch(function () {
          self.close();
        });
    };

    Ctor.prototype.atlekxPatched = true;
  }

  function boot() {
    initMegaMenu();
    initMobilePanels();
    patchPredictiveLimit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
